module.exports = __webpack_public_path__ + "static/media/mode-34.952dd3f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-34.svg
// module id = 989
// module chunks = 2